import React from "react";

import { useField } from "formik";

import { BaseInput } from "components/Form/FormikControls";

export const NVDNumberField = React.memo(
  ({ name, label, required, disabled = false }) => {
    const [field, meta, helpers] = useField(name);

    const onChange = e => {
      if (e.target.value.length > 9) {
        return;
      }
      helpers.setTouched(true);
      field.onChange(name)(e);
    };

    const error = meta.touched && meta.error;

    // NVD numbers can be alphanumeric (e.g. "D12345678"), so this field must always
    // be type="text" - browsers, notably iOS Safari, fully block non-numeric
    // keystrokes on type="number" inputs, making alphanumeric NVDs impossible to enter.
    // inputMode is deliberately left at its text default for the same reason -
    // inputMode="numeric" swaps to a keypad with no letter keys on iOS Safari.
    return (
      <BaseInput
        required={required}
        label={label}
        name={name}
        maxLength={9}
        type="text"
        value={field.value || undefined}
        error={error}
        onChange={onChange}
        disableAutoComplete
        disabled={disabled}
      />
    );
  },
);
